export default {"src":"/_next/static/media/learn-more.11a391b9.svg","height":152,"width":338,"blurWidth":0,"blurHeight":0};